'use strict';

var React = require('react');
require('../../theme/breakpoints.js');
var useClickAway = require('../../hooks/useClickAway.js');
require('imask');
var useRefAndForward = require('../../hooks/useRefAndForward.js');
require('resize-observer-polyfill');
var styles = require('./styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const Dropdown = React.forwardRef(({ target, targetRef = null, targetClassName, targetStyle, isOpened, onOpenedChange, children, shouldAddToDomOnOpen, ...props }, ref) => {
    const overlayRef = useRefAndForward.useRefAndForward(null, ref);
    const containerRef = useRefAndForward.useRefAndForward(null, targetRef);
    useClickAway.useClickAway({
        containerRefs: [containerRef, overlayRef],
        listener: React.useCallback(() => {
            if (isOpened)
                onOpenedChange(false);
        }, [isOpened, onOpenedChange]),
    });
    return (React__default.default.createElement(React__default.default.Fragment, null,
        React__default.default.createElement(styles.Styled.Container, { ref: containerRef, className: targetClassName, style: targetStyle, onClick: () => onOpenedChange(!isOpened) }, target),
        (!shouldAddToDomOnOpen || (shouldAddToDomOnOpen && isOpened)) && (React__default.default.createElement(styles.Styled.Overlay, { ...props, ref: overlayRef, targetRef: containerRef, isOpened: isOpened }, children))));
});

exports.Dropdown = Dropdown;
//# sourceMappingURL=component.js.map
